/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：801
 */

"use strict"

export { g as b }
export { g$Consumer as a }
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../19"
import { useContext, createElement, createContext } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_35 from /* 35 */"../35"
import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
import * as /* [auto-meaningful-name] */Module_694 from /* 694 */"./694/index"
var u = function () {
  var e = (0, useContext(g).getPrefixCls)("empty-img-default")
  return createElement("svg", {
    className: e,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, createElement("g", {
    transform: "translate(24 31.67)"
  }, createElement("ellipse", {
    className: "".concat(e, "-ellipse"),
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), createElement("path", {
    className: "".concat(e, "-path-1"),
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }), createElement("path", {
    className: "".concat(e, "-path-2"),
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    transform: "translate(13.56)"
  }), createElement("path", {
    className: "".concat(e, "-path-3"),
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), createElement("path", {
    className: "".concat(e, "-path-4"),
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  })), createElement("path", {
    className: "".concat(e, "-path-5"),
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }), createElement("g", {
    className: "".concat(e, "-g"),
    transform: "translate(149.65 15.383)"
  }, createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))))
}
var l = function () {
  var e = (0, useContext(g).getPrefixCls)("empty-img-simple")
  return createElement("svg", {
    className: e,
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, createElement("ellipse", {
    className: "".concat(e, "-ellipse"),
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), createElement("g", {
    className: "".concat(e, "-g"),
    fillRule: "nonzero"
  }, createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    className: "".concat(e, "-path")
  }))))
}
var f = function (e, t) {
  var n = {}
  for (var r in e) if (Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0) {
    n[r] = e[r]
  }
  if (null != e && "function" === typeof Object.getOwnPropertySymbols) {
    var i = 0
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
      if (t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i])) {
        n[r[i]] = e[r[i]]
      }
    }
  }
  return n
}
var d = createElement(u, null)
var h = createElement(l, null)
var p = function (e) {
  var /* [auto-meaningful-name] */e$className = e.className
  var /* [auto-meaningful-name] */e$prefixCls = e.prefixCls
  var /* [auto-meaningful-name] */e$image = e.image
  var u = undefined === e$image ? d : e$image
  var /* [auto-meaningful-name] */e$description = e.description
  var /* [auto-meaningful-name] */e$children = e.children
  var /* [auto-meaningful-name] */e$imageStyle = e.imageStyle
  var A = f(e, ["className", "prefixCls", "image", "description", "children", "imageStyle"])
  var v = useContext(g)
  var /* [auto-meaningful-name] */v$getPrefixCls = v.getPrefixCls
  var /* [auto-meaningful-name] */v$direction = v.direction
  return createElement(Module_694.a, {
    componentName: "Empty"
  }, function (e) {
    var a
    var c = v$getPrefixCls("empty", e$prefixCls)
    var f = "undefined" !== typeof e$description ? e$description : e.description
    var d = "string" === typeof f ? f : "empty"
    var g = null
    g = "string" === typeof u ? createElement("img", {
      alt: d,
      src: u
    }) : u
    return createElement("div", Module_19.a({
      className: Classnames1(c, (a = {}, Module_35.a(a, "".concat(c, "-normal"), u === h), Module_35.a(a, "".concat(c, "-rtl"), "rtl" === v$direction), a), e$className)
    }, A), createElement("div", {
      className: "".concat(c, "-image"),
      style: e$imageStyle
    }, g), f && createElement("div", {
      className: "".concat(c, "-description")
    }, f), e$children && createElement("div", {
      className: "".concat(c, "-footer")
    }, e$children))
  })
}
p.PRESENTED_IMAGE_DEFAULT = d
p.PRESENTED_IMAGE_SIMPLE = h
var _ = p
var A = function (e) {
  return createElement(g$Consumer, null, function (t) {
    var n = (0, t.getPrefixCls)("empty")
    switch (e) {
      case "Table":
      case "List":
        return createElement(_, {
          image: _.PRESENTED_IMAGE_SIMPLE
        })
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return createElement(_, {
          image: _.PRESENTED_IMAGE_SIMPLE,
          className: "".concat(n, "-small")
        })
      default:
        return createElement(_, null)
    }
  })
}
var g = createContext({
  getPrefixCls: function (e, t) {
    return t || (e ? "ant-".concat(e) : "ant")
  },
  renderEmpty: A
})
var /* [auto-meaningful-name] */g$Consumer = g.Consumer
export default g$Consumer
